import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, type ReactNode } from 'react';
import { ProfilePhoto, type ProfilePhotoProps } from '../profile-photo/profile-photo';
import styles from './profile-photo-with-badge.module.scss';
const ProfilePhotoContainerComponent = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className={styles["profile-photo-container"]} data-testid="profile-photo-container">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const ProfilePhotoWithBadge = t0 => {
  const $ = _c(12);
  let badge;
  let handleModalOpen;
  let profilePhotoProps;
  let restTriggerProps;
  if ($[0] !== t0) {
    ({
      badge,
      handleModalOpen,
      profilePhotoProps,
      ...restTriggerProps
    } = t0);
    $[0] = t0;
    $[1] = badge;
    $[2] = handleModalOpen;
    $[3] = profilePhotoProps;
    $[4] = restTriggerProps;
  } else {
    badge = $[1];
    handleModalOpen = $[2];
    profilePhotoProps = $[3];
    restTriggerProps = $[4];
  }
  let t1;
  if ($[5] !== badge) {
    t1 = badge && <div className={styles["profile-photo-container__badge"]} data-testid="profile-photo-badge">{badge}</div>;
    $[5] = badge;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const BadgeComponent = t1;
  let t2;
  if ($[7] !== BadgeComponent || $[8] !== handleModalOpen || $[9] !== profilePhotoProps || $[10] !== restTriggerProps) {
    t2 = <>{handleModalOpen ? <ProfilePhotoContainerComponent><button {...restTriggerProps} className={styles["profile-photo-container__button"]} data-testid="profile-photo-container-button" onClick={() => {
          handleModalOpen();
        }} type="button"><ProfilePhoto {...profilePhotoProps} /></button>{BadgeComponent}</ProfilePhotoContainerComponent> : <ProfilePhotoContainerComponent><ProfilePhoto {...profilePhotoProps} hasHoverOverlay={false} />{BadgeComponent}</ProfilePhotoContainerComponent>}</>;
    $[7] = BadgeComponent;
    $[8] = handleModalOpen;
    $[9] = profilePhotoProps;
    $[10] = restTriggerProps;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};